import { ReactNode } from "react";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

export interface ButtonArrowForwardProps {
    title: string;
    outlined?: boolean;
    fill?: boolean;
    transparent?: boolean;
    textSize?: 'm' | 'l';
    onClick: (e: any) => void;
    widthFit?: boolean;
    icon?: ReactNode;
    iconPosition?: "left" | "right";
}

export const ButtonArrowForward: React.FC<ButtonArrowForwardProps> = (btn) => {
    return (
        <div className={`${btn.widthFit ? "lg:w-fit" : ""} w-full h-fit`}>
            <button className={`${btn.widthFit ? "lg:w-fit" : ""} w-full px-2 pl-4 gap-2 ${btn.outlined ? "border-2 border-primary text-primary hover:text-primary_darker bg-transparent py-1.5 hover:border-primary_darker hover:bg-transparent" : "ring-0 bg-primary text-white py-2"} ${btn.textSize == 'l' ? 'text-lg lg:text-xl' : ''} ${btn.iconPosition === "right" && "flex-row-reverse"} font-medium rounded-xl shadow-sm hover:bg-primary_darker transition duration-150 flex flex-row justify-center items-center`}
            onClick={btn.onClick}>
                {btn.icon && 
                <div className="h-[20px] w-[20px] mr-1 z-20">
                    <ArrowOutwardIcon style={{width: "20px", marginTop: "-5px"}}/>
                </div>
                }
                <div>
                    {btn.title}
                </div>
            </button>
        </div>
    )
}